import styled, { css } from 'styled-components';

import colors from '../../style/colors';
import BaseCard, { BaseCardProps } from './base-card';

const CardBorder = styled(BaseCard)<BaseCardProps>`
  transition: all 600ms ease;
  background: ${colors.white};
  border: 1px solid ${colors.gray300};

  ${({ clickable, theme }) =>
    clickable !== false
      ? css`
          &:hover:not(.disabled):not([disabled]) {
            box-shadow: 0 8px 8px -4px rgba(0, 0, 0, 0.12);
            cursor: pointer;
          }

          &:focus-visible,
          &.active {
            border-color: ${theme.actionColor};
          }
        `
      : undefined}
`;

export default CardBorder;
